import React from 'react'
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from '../component/Home/Home'
import ReturnType from '../component/Home/ReturnType';
import ProductList from '../component/Product/ProductList';
import SummaryProduct from '../component/Product/SummaryProduct';
import UploadRefund from '../component/Upload/UploadRefund';
import ReturnSummary from '../component/Summary/ReturnSummary';
import InvoicePage from '../component/Invoice/InvoicePage';
import InvoiceProduct from '../component/Invoice/InvoiceProduct';
import InvoiceSummary from '../component/Summary/InvoiceSummary';
import MissingType from '../component/Missing/MissingType';
import MissingWarning from '../component/Missing/MissingWarning';
import MissingSummary from '../component/Missing/MissingSummary';
import MissingProduct from '../component/Missing/MissingProduct';
import MissingProductSummary from '../component/Missing/MissingProductSummary';





const AppRouter = () => {
  return (
   <BrowserRouter>
        <Routes>
            <Route path="/" element={<Home/>}/>
            <Route path="/return-type" element={<ReturnType/>}/>
            <Route path="/product-list" element={<ProductList/>}/>
            <Route path="/summary-list" element={<SummaryProduct/>}/>
            <Route path="/upload-picture" element={<UploadRefund/>}/>
            <Route path="/return-summary" element={<ReturnSummary/>}/>
            <Route path="/invoice-page" element={< InvoicePage/>}/>
            <Route path="/invoice-product" element={< InvoiceProduct/>}/>
            <Route path="/invoice-summary" element={< InvoiceSummary/>}/>
            <Route path="/missing-type" element={< MissingType/>}/>
            <Route path="/missing-warning" element={< MissingWarning/>}/>
            <Route path="/missing-summary" element={< MissingSummary/>}/>
            <Route path="/missing-product" element={< MissingProduct/>}/>
            <Route path="/missing-summary-product" element={< MissingProductSummary/>}/>
        </Routes>
   </BrowserRouter>
  )
}

export default AppRouter